export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/roger-keller-02e953fc50dd5b8d33d4545ae35ca59e.jpg";